// actions
export const ACT_SYNC_CLIENT_GUEST_INFO = "ACT_SYNC_CLIENT_GUEST_INFO";

//getters
export const IS_GUEST = "IS_GUEST";
